import { ReportHandler } from 'web-vitals';
import { AnalyticsService } from './services/AnalyticsService';
import { ANALYTICS_EVENTS } from './types/AnalyticsConstants';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      const analyticsService = AnalyticsService.getInstance();
      
      // Create enhanced handler that sends to both original handler and analytics
      const enhancedHandler: ReportHandler = (metric) => {
        // Call original handler
        onPerfEntry(metric);
        
        // Send to analytics if performance thresholds are exceeded
        // Check both explicit rating (if available) and value thresholds
        const rating = (metric as any).rating;
        const isPerformanceIssue = rating === 'poor' || 
                                  (rating === 'needs-improvement' && metric.value > getThreshold(metric.name)) ||
                                  (!rating && metric.value > getThreshold(metric.name));
        
        if (isPerformanceIssue) {
          analyticsService.trackPerformance({
            event_name: ANALYTICS_EVENTS.SYSTEM.PERFORMANCE_ISSUE,
            metric_name: metric.name as 'LCP' | 'FID' | 'CLS' | 'custom',
            value: metric.value,
            threshold_exceeded: true
          });
        }
      };
      
      getCLS(enhancedHandler);
      getFID(enhancedHandler);
      getFCP(enhancedHandler);
      getLCP(enhancedHandler);
      getTTFB(enhancedHandler);
    });
  }
};

// Define performance thresholds for "needs improvement" ratings
const getThreshold = (metricName: string): number => {
  switch (metricName) {
    case 'CLS': return 0.1; // Cumulative Layout Shift
    case 'FID': return 100; // First Input Delay (ms)
    case 'LCP': return 2500; // Largest Contentful Paint (ms)
    case 'FCP': return 1800; // First Contentful Paint (ms)
    case 'TTFB': return 800; // Time to First Byte (ms)
    default: return 0;
  }
};

export default reportWebVitals;
